function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const RevertIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.156 2.245a1 1 0 0 1 .099 1.411L5.194 6.027h8.258c4.16 0 7.548 3.343 7.548 7.487C21 17.657 17.612 21 13.452 21H8.5a1 1 0 1 1 0-2h4.952C16.525 19 19 16.535 19 13.514c0-3.022-2.475-5.487-5.548-5.487h-8.4l2.236 2.857a1 1 0 0 1-1.576 1.232l-3.5-4.473a1 1 0 0 1 .033-1.272l3.5-4.027a1 1 0 0 1 1.411-.099Z",
    clipRule: "evenodd"
  }));
};
export default RevertIcon;